(() => {
	const CELL_SIZE = 12
	const FRAME_TIME = 1650
	const START_DENSITY = 0.15

	const createGame = board => {
		let columns = 0
		let rows = 0
		let cells = []
		let state = new Uint8Array()
		let lastFrame = 0
		let animationFrame = 0
		let resizeTimer = 0

		const render = () => {
			cells.forEach((cell, index) => {
				cell.classList.toggle('alive', state[index] === 1)
			})
		}

		const seed = () => {
			state = Uint8Array.from(
				{ length: columns * rows },
				() => Math.random() < START_DENSITY ? 1 : 0
			)
		}

		const build = () => {
			columns = Math.ceil(window.innerWidth / CELL_SIZE)
			rows = Math.ceil(window.innerHeight / CELL_SIZE)
			const fragment = document.createDocumentFragment()

			cells = Array.from({ length: columns * rows }, () => {
				const cell = document.createElement('span')
				cell.className = 'cell'
				fragment.append(cell)
				return cell
			})

			board.style.setProperty('--gol-columns', columns)
			board.style.setProperty('--gol-rows', rows)
			board.replaceChildren(fragment)
			seed()
			render()
		}

		const nextGeneration = () => {
			const nextState = new Uint8Array(state.length)

			for (let row = 0; row < rows; row += 1) {
				for (let column = 0; column < columns; column += 1) {
					const index = row * columns + column
					let neighbours = 0

					for (let rowOffset = -1; rowOffset <= 1; rowOffset += 1) {
						for (let columnOffset = -1; columnOffset <= 1; columnOffset += 1) {
							if (rowOffset === 0 && columnOffset === 0) continue

							const neighbourRow = row + rowOffset
							const neighbourColumn = column + columnOffset

							if (
								neighbourRow >= 0 && neighbourRow < rows &&
								neighbourColumn >= 0 && neighbourColumn < columns
							) {
								neighbours += state[neighbourRow * columns + neighbourColumn]
							}
						}
					}

					nextState[index] = neighbours === 3 || (state[index] === 1 && neighbours === 2) ? 1 : 0
				}
			}

			state = nextState
			render()
		}

		const animate = time => {
			if (time - lastFrame >= FRAME_TIME) {
				nextGeneration()
				lastFrame = time
			}

			animationFrame = window.requestAnimationFrame(animate)
		}

		const start = () => {
			if (!animationFrame) {
				animationFrame = window.requestAnimationFrame(animate)
			}
		}

		const stop = () => {
			window.cancelAnimationFrame(animationFrame)
			animationFrame = 0
		}

		build()
		start()

		window.addEventListener('resize', () => {
			window.clearTimeout(resizeTimer)
			resizeTimer = window.setTimeout(build, 150)
		})

		document.addEventListener('visibilitychange', () => {
			document.hidden ? stop() : start()
		})
	}

	const init = () => {
		document.querySelectorAll('.redaxo section.spezialnetzwerk .gameoflife').forEach(createGame)
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init, { once: true })
	} else {
		init()
	}
})()
